import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModulLocatiiServiciiActive, ModulLocatiiServiciiActiveUpdate } from './mod-loc-servicii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModLocServiciiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getModuleLocatiiServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.getModuleLocatiiServicii;
    private storeModulLocatiiServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.storeModulLocatiiServicii;
    private updateModulLocatiiServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.updateModulLocatiiServicii;
    private deleteModulLocatiiServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.deleteModulLocatiiServicii;
    private findByModuleUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.findByModule;
    private moveUpUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.moveUp;
    private moveDownUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.moduleLocatiiServiciiActive.moveDown;

    constructor(private http: HttpClient) { }

    addModulLocatiiServicii(modulLocatiiServicii: ModulLocatiiServiciiActive) {
        return this.http.post(this.storeModulLocatiiServiciiUrl, modulLocatiiServicii, this.httpOptions);
    }

    updateModulLocatiiServicii(modulLocatiiServicii: ModulLocatiiServiciiActiveUpdate) {
        return this.http.put(this.updateModulLocatiiServiciiUrl, modulLocatiiServicii, this.httpOptions);
    }

    deleteModulLocatiiServicii(id: number) {
        return this.http.delete(this.deleteModulLocatiiServiciiUrl + id);
    }

    getModuleLocatiiServicii() {
        return this.http.get(this.getModuleLocatiiServiciiUrl, this.httpOptions);
    }

    findByModule(id: number) {
        return this.http.get(this.findByModuleUrl + id).pipe(
            map((response: any) => response.data),
            catchError((error) => {
                console.error('Error in find module locatii servicii by module:', error);
                return throwError(error);
            })
        );
    }

    moveUp(id: number) {
        return this.http.put(this.moveUpUrl + id, this.httpOptions);
    }

    moveDown(id: number) {
        return this.http.put(this.moveDownUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
